module.exports = __webpack_public_path__ + "img/no-data.5d0b945.png";